import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import image from "./assets/img/airagon.png";
import image2 from "./assets/img/scripting.png";
import carMeet from "./assets/img/car-meet-app.png";

class DemoCarousel extends Component {
  render() {
    return (
      <Carousel>
        <div>
          <img src={image2} alt="Web scraper program for Crowdvolt.com" />
          <p className="legend">
            Web scraper program for Crowdvolt.com that scrapes current listing,
            lets you select and monitor specific ticket prices. (built with
            python)
          </p>
        </div>
        <div>
          <img src={image} alt="Checkout automation program" />
          <p className="legend">
            Checkout automation program built with python
          </p>
        </div>
        <div>
          <img src={carMeet} alt="Car meet app interface" />
          <p className="legend">
            Car meets: my program that lets user view a map of all local car
            meets. (built with react native)
          </p>
        </div>
      </Carousel>
    );
  }
}

export default DemoCarousel;
// Don't forget to include the css in your page

// Using webpack or parcel with a style loader
// import styles from 'react-responsive-carousel/lib/styles/carousel.min.css';

// Using html tag:
// <link rel="stylesheet" href="<NODE_MODULES_FOLDER>/react-responsive-carousel/lib/styles/carousel.min.css"/>
